
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tow-truck-near-me",
      function () {
        return require("private-next-pages/tow-truck-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tow-truck-near-me"])
      });
    }
  